import { getExperienceValues } from "@/utils/experienceUtils";
import { getVisualBuilderMode } from "@/utils/visualBuilder";

import * as types from "./types";
import { REQUEST_STATUSES, TAB_STATUSES, VB_MODE } from "../../../constants";
import { ExperienceService, PublicVisualizationService } from "../../../services";
import { updateVisualBuilderData } from "../visualBuilderData/actions";
import { visualBuilderDataSelector } from "../visualBuilderData/selectors";

export function transformExperienceData(arg) {
  const experience = arg ?? {}; // not sure why default arguments aren't working in the browser

  experience.experienceTagIds = {};
  experience.experienceContentTypeIds = {};
  experience.contentTypesOrdered = {};
  experience.contentTypesOrdered = {};
  experience.tagsOrdered = {};
  experience.hiddenContentTypes = {};
  experience.hiddenTags = {};
  experience.tagNames = {};
  experience.experienceAssetCategoryIds = {};
  experience.assetCategoriesOrdered = {};
  experience.hiddenAssetCategories = {};
  experience.assetCategoryNames = {};

  if (experience.experienceTags?.length) {
    experience.experienceTags.forEach((experienceTag) => {
      experience.experienceTagIds[experienceTag.id] = true;
      experience.tagsOrdered[experienceTag.id] = experienceTag?.ExperienceTag?.order ?? experienceTag?.order;
      experience.hiddenTags[experienceTag.id] = experienceTag?.ExperienceTag?.hidden ?? experienceTag?.hidden;
      experience.tagNames[experienceTag.id] = experienceTag?.ExperienceTag?.name ?? experienceTag?.name;
    });
  }

  if (experience.experienceContentTypes?.length) {
    experience.experienceContentTypes.forEach((experienceContentType) => {
      experience.experienceContentTypeIds[experienceContentType.id] = true;
      experience.contentTypesOrdered[experienceContentType.id] =
        experienceContentType?.ExperienceContentType?.order ?? experienceContentType?.order;
      experience.hiddenContentTypes[experienceContentType.id] =
        experienceContentType?.ExperienceContentType?.hidden ?? experienceContentType?.hidden;
    });
  }

  if (experience.experienceAssetCategories?.length) {
    experience.experienceAssetCategories.forEach((experienceAssetCategory) => {
      const id = experienceAssetCategory.assetCategoryId || -1;
      experience.experienceAssetCategoryIds[id] = true;
      experience.assetCategoriesOrdered[id] =
        experienceAssetCategory?.ExperienceAssetCategory?.order ?? experienceAssetCategory?.order;
      experience.hiddenAssetCategories[id] =
        experienceAssetCategory?.ExperienceAssetCategory?.hidden ?? experienceAssetCategory?.hidden;
      experience.assetCategoryNames[id] =
        experienceAssetCategory?.ExperienceAssetCategory?.name ?? experienceAssetCategory?.name;
    });
  }

  return { experience };
}

export const getCurrentExperience = (params, query) => {
  return async (dispatch, getState) => {
    const { propertyId, experienceId, tabStatus } = params;

    dispatch({
      type: types.SET_CURRENT_EXPERIENCE_REQUEST_STATUS,
      payload: { propertyId, experienceId, status: REQUEST_STATUSES.LOADING },
    });

    let payload = {};

    if (tabStatus !== TAB_STATUSES.PUBLIC) {
      const { resp, status, err } = await ExperienceService.getExperience(propertyId, experienceId, query);

      payload = { ...payload, status, err, ...transformExperienceData(resp) };
    } else {
      const { resp, status, err } = await PublicVisualizationService.getPublicExperience(
        propertyId,
        experienceId,
        query,
      );

      payload = { ...payload, status, err, ...transformExperienceData(resp) };
    }

    dispatch({ type: types.GET_CURRENT_EXPERIENCE, payload });

    const { mode } = getVisualBuilderMode(params);
    const { visualBuilderData } = visualBuilderDataSelector(params)(getState());

    if ([TAB_STATUSES.COLLECT, TAB_STATUSES.CUSTOMIZE].includes(tabStatus) && payload.experience) {
      dispatch(updateVisualBuilderData(params, {}, { locked: payload.experience.locked }));
    }

    if (mode === VB_MODE.PUBLIC_VISUALIZATION && visualBuilderData.id) {
      dispatch(updateVisualBuilderData(params, {}, getExperienceValues(payload.experience), true));
    }
  };
};

export const resetCurrentExperience = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_EXPERIENCE,
      payload: {},
    });
  };
};

export const updateExperienceActivityOpened = (propertyId, experience, activity) => {
  return async (dispatch) => {
    try {
      const { resp, status, err } = await ExperienceService.updatePublicExperience(propertyId, experience.id, {
        activity,
      });

      const transformedExperience = transformExperienceData({
        ...experience,
        activity,
      });

      dispatch({
        type: types.UPDATE_EXPERIENCE_ACTIVITY,
        payload: { propertyId, experience: transformedExperience.experience, activity, resp, status, err },
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_EXPERIENCE_ACTIVITY,
        payload: { propertyId, experience, activity, status: REQUEST_STATUSES.ERROR, err },
      });
    }
  };
};

export const updateCurrentExperience = (currentExperience) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.UPDATE_CURRENT_EXPERIENCE, payload: currentExperience });
    } catch (err) {
      dispatch({
        type: types.SET_CURRENT_EXPERIENCE_REQUEST_STATUS,
        payload: { status: REQUEST_STATUSES.FAILED, err },
      });
    }
  };
};
